// @mui material components
import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// add useTheme and useMediaQuery
import { Card, CardContent, Typography, Box, Avatar, Icon } from "@mui/material";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { allUsers, getDashboardStats, getCategoriesWithListings } from "services/apiService";
import CATEGORIES from "data/categoriesData";
import { normalizeDashboardCategories } from "utils/dashboardCategoryUtils";

function Dashboard() {
  const navigate = useNavigate();
  const [usersCount, setUsersCount] = useState(0);
  const [todaysUsers, setTodaysUsers] = useState(0);
  const [totalListings, setTotalListings] = useState(0);
  const [pendingApprovals, setPendingApprovals] = useState(0);
  const [totalDealers, setTotalDealers] = useState(0);
  const [vehiclesSold, setVehiclesSold] = useState(0);
  const [categoriesWithVehicleCounts, setCategoriesWithVehicleCounts] = useState(
    normalizeDashboardCategories([], CATEGORIES)
  );

  useEffect(() => {
    (async () => {
      await getAllUsers();
      await fetchDashboardStats();
      await fetchCategoriesWithListings();
    })();
  }, []);

  const getAllUsers = async () => {
    try {
      const response = await allUsers();
      if (response?.success) {

        const usersVerified = response?.data?.users
          .filter((u) => u.isVerified)

        const totalUsers = usersVerified?.length;

        const today = new Date().toISOString().slice(0, 10);
        const usersAddedToday = response?.data?.users?.filter(
          (user) => user.createdAt.slice(0, 10) === today
        ).length;

        setUsersCount(totalUsers);
        setTodaysUsers(usersAddedToday);
      }
    } catch (err) {
      console.error("Fetch users failed:", err);
    }
  };

  const fetchDashboardStats = async () => {
    try {
      const response = await getDashboardStats();
      console.log("Dashboard stats response:", response);
      if (response?.success) {
        setTotalListings(response?.data?.totalListings ?? 0);
        setPendingApprovals(response?.data?.pendingApprovals ?? 0);
        setTotalDealers(response?.data?.totalDealers ?? 0);
        setVehiclesSold(response?.data?.vehiclesSold ?? 0);
      }
    } catch (err) {
      console.error("Fetch dashboard stats failed:", err);
    }
  };

  const fetchCategoriesWithListings = async () => {
    try {
      const response = await getCategoriesWithListings({ status: "active" });
      if (response?.success) {
        setCategoriesWithVehicleCounts(normalizeDashboardCategories(response?.data || [], CATEGORIES));
      }
    } catch (err) {
      console.error("Fetch categories with listings failed:", err);
      setCategoriesWithVehicleCounts(normalizeDashboardCategories([], CATEGORIES));
    }
  };
  const goToCategoryListings = (category) => {
    const categoryId = category?.id ?? category?._id;
    navigate(
      categoryId === undefined || categoryId === null
        ? "/vehicle-approvals"
        : `/vehicle-approvals?categoryId=${encodeURIComponent(categoryId)}`
    );
  };

  console.log('categoriesWithVehicleCounts',categoriesWithVehicleCounts);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="person_add"
                title="Total Users"
                onClick={() => navigate("/users")}
                count={usersCount}
                percentage={{
                  color: "success",
                  amount: todaysUsers,
                  label: "Added today",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                icon="category"
                title="Total Categories"
                onClick={() => navigate("/categories")}
                count={CATEGORIES.length}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "All categories",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="directions_car"
                title="Total Vehicles"
                onClick={() => navigate("/vehicle-approvals")}
                count={totalListings}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "All listings",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon="pending_actions"
                title="Pending Approvals"
                onClick={() => navigate("/vehicle-approvals?status=pending")}
                count={pendingApprovals}
                percentage={{
                  color: "text",
                  amount: "",
                  label: "Awaiting review",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                icon="store"
                title="Total Dealers"
                onClick={() => navigate("/users?isVerifiedDealer=true")}
                count={totalDealers}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Registered dealers",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="sell"
                title="Vehicles Sold"
                onClick={() => navigate("/vehicle-approvals?status=sold")}
                count={vehiclesSold}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Completed sales",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>

        <MDBox py={1}>
          <MDBox>
            <Card>
              <CardContent sx={{ padding: 3 }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  All Categories
                </Typography>
                <Box mt={2}>
                  {categoriesWithVehicleCounts.length > 0 ? (
                    categoriesWithVehicleCounts.map((category) => (
                      <Box
                        key={category.id}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        py={1.5}
                        px={1}
                        role="button"
                        tabIndex={0}
                        onClick={() => goToCategoryListings(category)}
                        onKeyDown={(event) => {
                          if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            goToCategoryListings(category);
                          }
                        }}
                        sx={{
                          borderBottom: "1px solid",
                          borderColor: "divider",
                          cursor: "pointer",
                          borderRadius: 1,
                          transition: "background-color 150ms ease",
                          "&:hover": { backgroundColor: "grey.100" },
                        }}
                      >
                        <Box display="flex" alignItems="center" gap={1.5}>
                          <Avatar
                            src={category.icon || undefined}
                            alt={category.name}
                            variant="rounded"
                            sx={{ width: 36, height: 36, bgcolor: "grey.200" }}
                          >
                            {category.icon  ? (
                              <Icon fontSize="small">{category.icon}</Icon>
                            ) : (
                              category.name.charAt(0)
                            )}
                          </Avatar>
                          <Typography variant="subtitle2">{category.name}</Typography>
                        </Box>
                        <Typography variant="subtitle2" color="text.secondary">
                          {category.vehicleCount} {category.vehicleCount === 1 ? "vehicle" : "vehicles"}
                        </Typography>
                      </Box>
                    ))
                  ) : (
                    <Typography mt={2}>No categories available</Typography>
                  )}
                </Box>
              </CardContent>
            </Card>
          </MDBox>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;
